import ActionsSection from './ActionsSection'
import Wrapper from './Navbar'
import Title from './Title'

const components = { ActionsSection, Title, Wrapper }

export default components
